<script lang="ts">
  import { minecraftRuntimeAdvice } from "@mars-host/shared";
  const {
    core,
    version,
    memoryMb = 1024,
  }: { core: string; version: string; memoryMb?: number } = $props();
  const warnings = $derived(
    version ? minecraftRuntimeAdvice(core, version, memoryMb).warnings : [],
  );
</script>
{#each warnings as warning (warning)}
  <p class="runtime-warning" role="status">
    {warning} Большой мир, плагины и моды могут потребовать дополнительную память.
  </p>
{/each}
<style>
  .runtime-warning {
    padding: 0.8rem 1rem;
    border-left: 3px solid var(--amber);
    background: var(--surface);
    color: var(--cream);
    font-size: 0.85rem;
    line-height: 1.6;
  }
</style>
